import MakeTag from "../makeTag/MakeTag";
export default function AngularTag() {
    return (<>
		<MakeTag tagText="Angular" color="#e23237" />
		<MakeTag tagText="TypeScript" color="#3178c6" />
		<MakeTag tagText="JavaScript" color="rgb(232, 210, 22)" />
		<MakeTag tagText="HTML" color="#dd4b24" />
		<MakeTag tagText="CSS" color="#254bdd" />

		</>);
}